import LogoCryptoCurrency from "app/components/Logos/LogoCryptoCurrency";
import { useState } from "react";
import { injectIntl, IntlShape } from "react-intl";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import type { UserType } from "../../../../types/userType";
import ManageFundingLogoHeader from "../../components/ManageFundingLogoHeader/ManageFundingLogoHeader";
import CryptoFundingDeposit from "./components/CryptoFundingDeposit/CryptoFundingDeposit";
import CryptoFundingWithdraw from "./components/CryptoFundingWithdraw/CryptoFundingWithdraw";
import CryptoPendingTransactions from "./components/CryptoPendingTransactions/CryptoPendingTransactions";
import "./CryptoFundingScreen.scss";

export const tabs = {
  DEPOSIT: "DEPOSIT",
  WITHDRAWAL: "WITHDRAWAL",
};

function CryptoFundingScreen(props: { user: UserType; intl: IntlShape }) {
  const { user, intl } = props;
  const history = useHistory();
  const [tab, setTabValue] = useState(tabs.DEPOSIT);

  const getTabs = () => {
    return [
      {
        title: intl.formatMessage({
          id: "cashier-deposit",
        }),
        callback: () => setTab(tabs.DEPOSIT),
        isActive: tab === tabs.DEPOSIT,
        id: "cashier-deposit",
      },
      {
        //translate titles
        title: intl.formatMessage({
          id: "cashier-withdraw",
        }),
        callback: () => setTab(tabs.WITHDRAWAL),
        isActive: tab === tabs.WITHDRAWAL,
        id: "cashier-withdraw",
      },
    ];
  };

  const setTab = (tabType: string) => {
    if (tab === tabType) {
      return null;
    }
    setTabValue(tabType);
  };

  return (
    <div className="crypto-funding">
      <ManageFundingLogoHeader
        history={history}
        getTabs={getTabs()}
        logo={<LogoCryptoCurrency />}
      />
      <CryptoPendingTransactions
        currentTab={tab}
        userCurrency={user.currencyCode}
        tabs={tabs}
      />
      <div className="crypto-funding__content">
        {tab === tabs.DEPOSIT && <CryptoFundingDeposit user={user} />}
        {tab === tabs.WITHDRAWAL && <CryptoFundingWithdraw user={user} />}
      </div>
    </div>
  );
}

const mapStateToProps = state => ({
  user: state.userModel.user,
});

export default connect(mapStateToProps, null)(injectIntl(CryptoFundingScreen));
